module.exports = __webpack_public_path__ + "assets/img/yypt_bn_1.de5667d3.png";